import _ from 'lodash';
//import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import GmAdderChangeContainer from '../../containers/accounting/GmAdderChanges';

import { getSharedStyles } from '../../themes';
import EnhancedTable from '../../components/table/EnhancedTable';
import { Button, Typography } from '@material-ui/core';
import AddGmAdderDialog from '../../components/AddGmAdderDialog';
//import Button from '@material-ui/core/Button';
const styles = (theme) => ({
	...getSharedStyles(theme),
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	docContainer: {
		position: 'absolute',
	},
	addInputButton: {
		borderRadius: '100px',
		marginBottom: 10,
	},
});

const gmAdderChangeColumns = [
	{
		sortId: 'gmAdderChangeId',
		displayId: 'gmAdderChangeId',
		labels: ['Change ID'],
	},

	{
		sortId: 'newValue',
		displayId: 'newValue',
		label: 'New Value',
	},
	{
		sortId: 'previousValue',
		displayId: 'previousValue',
		label: 'Previous Value',
	},

	{
		sortId: 'createdByDisplay',
		displayId: 'createdByDisplay',
		labels: ['Created By'],
	},

	{
		sortId: 'message',
		displayId: 'message',
		labels: ['Note'],
	},

	{
		sortId: 'startDate',
		displayId: 'dateCreatedFormatted',
		label: 'Date Created',
	},
];

class GmAdderChanges extends Component {
	constructor(props) {
		super(props);
		this.state = {
			order: 'desc',
			orderBy: 'dateCreated',
			isAddDialogOpen: false,
		};
	}

	componentDidMount() {
		const { gmAdderChangeSearch } = this.props;
		gmAdderChangeSearch();
	}

	componentDidUpdate(prevProps) {
		const { gmAdderChanges } = this.props;
		if (prevProps.gmAdderChanges !== gmAdderChanges) {
			this.formatGmAdderChanges();
		}
	}

	formatGmAdderChanges = () => {
		const { gmAdderChanges, userMap } = this.props;
		const formattedGmAdderChanges = [];
		gmAdderChanges.forEach((gmAdderChange) => {
			const {
				gmAdderChangeId,
				//	newValue,
				//	previousValue,
				//message,
				createdByUserId,
				dateCreated,
			} = gmAdderChange;
			const createdByUser = userMap[createdByUserId] || { firstName: 'Missing' };

			gmAdderChange.key = gmAdderChangeId;
			gmAdderChange.createdByDisplay = createdByUser.firstName;
			gmAdderChange.dateCreatedFormatted = moment(dateCreated).format('M/D h:mm a');
			formattedGmAdderChanges.push(gmAdderChange);
		});
		this.setState({ formattedGmAdderChanges });
	};

	handleCloseAddDialog = () => {
		this.setState({ isAddDialogOpen: false });
	};

	render() {
		const { classes, authUser, canRwGmAdder } = this.props;

		if (!canRwGmAdder) {
			return <div>You have invalid permissions to view this page.</div>;
		}

		const canMakeUpdates = _.get(authUser, ['permissions', 'canMakeUpdates']);
		const { formattedGmAdderChanges, order, orderBy } = this.state;

		if (!formattedGmAdderChanges) {
			return <div>Loading the GM Adder changes...</div>;
		}

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={8}>
							<Typography variant="h5" align="left" gutterBottom className={classes.title}>
								<span>GM Adder Change History</span>
							</Typography>
						</Grid>

						<Grid item xs={4} style={{ textAlign: 'right' }}>
							<Button
								onClick={() => {
									this.setState({ isAddDialogOpen: true });
								}}
								variant="contained"
								color="primary"
								className={classes.addInputButton}
								disabled={!canMakeUpdates}
								style={{ marginTop: 0 }}
							>
								Update Current GM Adder
							</Button>
						</Grid>
					</Grid>

					<Paper className={classes.paper}>
						<EnhancedTable
							columns={gmAdderChangeColumns}
							rows={formattedGmAdderChanges}
							defaultOrder={order}
							defaultOrderBy={orderBy}
						/>
					</Paper>
				</Grid>

				<AddGmAdderDialog
					onClose={this.handleCloseAddDialog}
					gmAdderChangeAdd={this.props.gmAdderChangeAdd}
					open={this.state.isAddDialogOpen}
					showErrors={this.props.showErrors}
				/>
			</Grid>
		);
	}
}

GmAdderChanges.propTypes = {
	canRwGmAdder: PropTypes.bool.isRequired,
	classes: PropTypes.object.isRequired,
	gmAdderChangeSearch: PropTypes.func.isRequired,
	gmAdderChangeAdd: PropTypes.func.isRequired,
	gmAdderChanges: PropTypes.array,
	showErrors: PropTypes.func.isRequired,
	userMap: PropTypes.object,
	history: PropTypes.object,
	theme: PropTypes.object.isRequired,
	authUser: PropTypes.object,
};

export default _.flow([withStyles(styles, { withTheme: true }), GmAdderChangeContainer])(
	GmAdderChanges
);
